import Header from "./TentangKami/Header";
import ApaItuDanai from "./TentangKami/ApaItuDanai";
import MengapaMemilihKami from "./TentangKami/MengapaMemilihKami";
import MilestoneSection from "./MilestoneSection";
import CeritaDanai from "./TentangKami/CeritaDanai";
import DibalikDanai from "./TentangKami/DibalikDanai";
import VisiMisi from "./TentangKami/VisiMisi";
import TabelLaporanKeuangan from "./TentangKami/TabelLaporanKeuangan";
import PemegangSaham from "./TentangKami/PemegangSaham";

function Index() {
    return (
        <div>
            <Header />
            <ApaItuDanai />
            <VisiMisi/>
            <MengapaMemilihKami />
            <MilestoneSection/>
            <CeritaDanai/>
            <DibalikDanai/>
            <PemegangSaham/>
            <TabelLaporanKeuangan/>
        </div>
    );
}

export default Index;
